import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { STEP_COUNT } from './constants';

type BookFormStepNavigationProps = {
  activeStep: number;
  onBack: () => void;
  onNext: () => void;
};

export default function BookFormStepNavigation({ activeStep, onBack, onNext }: BookFormStepNavigationProps) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}
    >
      <Button type="button" variant="outlined" disabled={activeStep === 0} onClick={onBack}>
        Буцах
      </Button>
      <Button type="button" variant="contained" disabled={activeStep >= STEP_COUNT - 1} onClick={onNext}>
        Дараах
      </Button>
    </Stack>
  );
}
